module.exports = __webpack_public_path__ + "media/images/pinterest-97216a8054a2b43f4377330c1dcd4770.png";